<template>
    <div class="expertise-container">
      <div class="expertise" v-for="(category, index) in categories" :key="index" @click="categoryClickHandler(category)">
        {{ category.name }}
      </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'FilterExpertise',
  data() {
    return {
      categories: [],
    }
  },
  methods: {
    categoryClickHandler(category) {
        window.dispatchEvent(new CustomEvent('update-expertise', {
          detail: {
            category: category
          }
        }));
    },
  },
  mounted() {
    axios.get(`${window.location.origin}/wp-json/wp/v2/expertise`)
    .then(response => {
      this.categories = response.data
    })
  },
}
</script>

<style lang="scss">
    .expertise-container {
      text-align: center;
      margin: 0 auto;
      justify-content: center;
      flex-direction: column;
      flex-wrap: wrap;

      @media screen and (min-width: 640px) {
        flex-direction: row;
      }
    }

    .expertise {
      cursor: pointer;
      margin: 0 15px;
      color: #999;
      padding: 20px;

      &:hover {
        text-decoration: underline;
        color: white;
      }
    }
</style>
